// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	company: 'atticus',
	name: 'Atticus en línea',
	firebase: {
		apiKey: "AIzaSyD444Tu_YtGaagcuMANfMYrNb3ftdljpmw",
		authDomain: "atticus-rixsi.firebaseapp.com",
		databaseURL: "https://atticus-rixsi.firebaseio.com",
		projectId: "atticus-rixsi",
		storageBucket: "atticus-rixsi.appspot.com",
		messagingSenderId: "193090023793",
		appId: "1:193090023793:web:1ef04c3bbabc88dc6e86d0"
	}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
